import React from 'react';
import styled from 'styled-components';
import { Circle } from 'lucide-react';

const FilterContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  align-items: center;
`;

const FilterButton = styled.button`
  padding: 0.3rem 0.6rem;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
  will-change: transform, background-color;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
  
  background-color: ${props => props.$active ? props.$bgColor : 'white'};
  color: ${props => props.$active ? props.$textColor : '#374151'};
  border-color: ${props => props.$active ? props.$bgColor : '#e5e7eb'};
  
  &:hover {
    background-color: ${props => props.$active ? props.$bgColor : '#f9fafb'};
  }
`;

const EventStatusFilters = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { value: 'all', label: 'All', bgColor: '#e5e7eb', textColor: '#4b5563' },
    { value: 'Hold', label: 'Hold', bgColor: '#fef3c7', textColor: '#92400e' },
    { value: 'In_Progress', label: 'In Progress', bgColor: '#dbeafe', textColor: '#1e40af' },
    { value: 'Complete', label: 'Complete', bgColor: '#dcfce7', textColor: '#166534' },
    { value: 'Canceled', label: 'Canceled', bgColor: '#fee2e2', textColor: '#991b1b' },
  ];

  const circleMap = {
    all: '#4b5563',
    Hold: '#92400e',
    In_Progress: '#1e40af',
    Complete: '#166534',
    Canceled: '#991b1b',
  };

  return (
    <FilterContainer>
        {/* Status:  */}
      {filters.map(filter => (
        <FilterButton
          key={filter.value}
          $active={activeFilter === filter.value}
          onClick={() => onFilterChange(filter.value)}
          $bgColor={filter.bgColor}
          $textColor={filter.textColor}
        >
          <Circle size={8} fill={circleMap[filter.value]} stroke={circleMap[filter.value]}/>
          {filter.label}
        </FilterButton>
      ))}
    </FilterContainer>
  );
};

export default EventStatusFilters;